export default [
    {
      path: '/website/enquiry',
      meta: { layout: "default", renderNavBar: true, renderSideBar: true },
      name: 'WebsiteEnquiry',
      component: () => import('@/pages/website/Enquiry/index.vue')
    },
    {
      path: '/website/community/user',
      meta: { layout: "default", renderNavBar: true, renderSideBar: true },
      name: 'CommunityUsers',
      component: () => import('@/pages/website/CommunityUsers/index.vue')
    },
    {
      path: '/website/business/enquiry',
      meta: { layout: "default", renderNavBar: true, renderSideBar: true },
      name: 'WebsiteBusinessQuestions',
      component: () => import('@/pages/website/Business/index.vue')
    },

    {
      path: '/website/rsvp/data',
      meta: { layout: "default", renderNavBar: true, renderSideBar: true },
      name: 'WebsiteRsvpData',
      component: () => import('@/pages/website/RsvpData/index.vue')
    },
]